
import { queryClient } from "utils/react-query";
import { toast } from "sonner";
import { useMutation } from "@tanstack/react-query";
import { deleteMeeting } from "./api";

export function useDeleteMeeting({ onSuccess }) {
    return useMutation({
        mutationFn: ({ meetingId }) => deleteMeeting({ meetingId }),
        onMutate: async ({ meetingId }) => {
            await queryClient.cancelQueries({ queryKey: ['calendar_events'] });
            const previousMeetings = queryClient.getQueryData(['calendar_events']);
            queryClient.setQueryData(['calendar_events'], (old) =>
                old?.filter((meeting) => meeting.id !== meetingId)
            );
            return { previousMeetings };
        },
        onError: (error) => {
            console.error(error);
            toast.error("Failed to delete the meeting");
        },
        onSuccess: () => {
            toast.success("Meeting Deleted Successfully");
            queryClient.invalidateQueries();
            onSuccess();
        },
    });
}
